import Icon, { ICON_ARROW_LEFT } from '~/components/icon/index.js';
import Link from '../router/query-encoded-link.js';

/**
 * @param {{href: string, className: string, 'data-at'?: string}} props
 */
const IconChevronLinkLeft = ({ href = '', className = '', 'data-at': dataAt = '' }) => (
	<Link href={href} className={className} data-at={dataAt}>
		<Icon type={ICON_ARROW_LEFT} className={className} />
	</Link>
);

export default IconChevronLinkLeft;
